/**
 * 海关编码-设置页 | 详情页
 *
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2021, all rights reserved. Essa.cn
 */
import React from 'react';
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import CopyAndPaste from "@components/CopyAndPaste/CopyAndPaste";
import ImageHover from "../../Components/ImageHover";
import {Spin, Row, Col, Upload, Button, Input, Descriptions, message, Modal} from 'antd';
import {Prompt} from 'react-router-dom';
import Lang from "@components/Lang/Lang";
import {isEmpty,trim,getFileSuffix} from '@utils/utils';
import  utilExcelStrict from '@utils/utilExcelStrict';
import "./Details.less";
import CustomsDeclarationStickerAction from "../../CustomsDeclarationSticker.action";
const DescItem =Descriptions.Item;
// const FormComponent = Form;
// const FormItem = FormComponent.Item;
const config = require("@config/config");
class Details extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            isHadEdit: false, //是否编码过
            isEdit: false, // 当前是可编码状态
            item:{},
            list: [
            ],
            uploadSetting : {
                name: 'file',
                accept:'.xlsx, .xls',
                showUploadList: false,
                beforeUpload:this.beforeUpload.bind(this),
                customRequest:this.handleUpload.bind(this),
            }
        }
        this.listener = e => {
            if(this.state.isHadEdit){
                e.preventDefault();
                e.returnValue = Lang({id:'LiKaiDangQianYeHou，SuoBianJiDeShuJuJiangBuKeHuiFu',default:'离开当前页后，所编辑的数据将不可恢复'}) // 浏览器有可能不会提示这个信息，会按照固定信息提示
            }
        }
    }
    /**
     * 查看详情
     * */
    getDetail(sId){
        this.loading(true);
        const postData = {
            id:sId,
            isSkuDetail:1,//是否需要sku详细信息		海关编码传1 其余传0
        }
        CustomsDeclarationStickerAction.getGoodsDetail(postData).then(res=>this.handleRes(res.data)).catch(err=>this.handleRes(err))
    }
    handleRes(res){
        this.loading(false);
        const {success,valid,model,models} = res;
        if(success&&valid){
            this.setState({
                item:model||{},
                list: models||[],
            })
        }
    }
    loading(flag) {
        this.setState({
            loading: flag,
        });
    }
    /**
     * 下载按钮
     * */
    handleDownExcel(list,sPoCode) {
        this.loading(true);
        const columns = [
            {
                header: Lang({id: 'ShangPin', default: '商品'}),
                key: 'skuPictureUrlno',
                width: 30,
            },
            {
                header: Lang({id: 'ShangPinMingChen', default: '商品名称'}),
                key: 'skuNameRu',
                width: 30,
            },
            {
                header: Lang({id: 'ShangPinMingChen', default: '商品名称'}),
                key: 'skuNameEn',
                width: 30,
            },
            {
                header: Lang({id: 'ShangPinBianMa', default: '商品编码'}),
                key: 'skuNo',
                width: 15,
            },
            {
                header: Lang({id: 'BaoZhuangNianLingBiaoQian', default: '包装年龄标签'}),
                key: 'mark',
                width: 20,
            },
            {
                header: Lang({id: 'CaiZhi', default: '材质'}),
                key: 'mainMaterials',
                width: 20,
            },
            {
                header: Lang({id: 'LeiMu', default: '类目'}),
                key: 'categoryName',
                width: 20,
            },
            {
                header: Lang({id: 'BaoZhuangLeiXing', default: '包装类型'}),
                key: 'packagingType',
                width: 15,
            },
            {
                header: Lang({id: 'HaiGuanBianMa', default: '海关编码'}),
                key: 'downCustomsCode',
                width: 15,
            }
        ]
        const downList = this.handleDownList(list);
        const fileName =  Lang({id:'TianXieHaiGuanBianMa', default:'填写海关编码'})+'_'+sPoCode
        utilExcelStrict.exportFile(columns, downList, fileName, res => {
            setTimeout(() => this.loading(false), 400)
        })
    }
    /**
     * 处理下载数据 TODO 优化合并在渲染页面时
     * */
    handleDownList(yList = []){
        let list = [...yList];
        let downList = [];
        list.forEach(item=>{
            const skuInfo = item.skuInfo||{};
            const attributeList = skuInfo.attributeList||[];
            const sPic = item.skuFileUrls&&item.skuFileUrls.length>0?item.skuFileUrls[0]:''; // 主图
            let packagingType = ''; // 包装类型
            let sMark = ''; // 包装年龄标签
            attributeList.forEach(att=>{
                if(att.attributeCode == 'PKG'){
                    let str = ""
                    if(att.optionList&&att.optionList.length>0)att.optionList.map(item=>str += item.optionName+"");
                    packagingType = str;
                }
                if(att.attributeCode == 'bznlb'){
                    let str = ""
                    if(att.optionList&&att.optionList.length>0)att.optionList.map(item=>str += item.optionName+"");
                    sMark = str
                }

            })
            let sDownCustomsCode = '';
            if(!isEmpty(item.customsCode)){
                if(item.customsCode.length==10){
                    sDownCustomsCode = item.customsCode;
                }
            }
            downList.push({
                thumbnail : sPic,
                skuPictureUrl: sPic,
                skuNameRu:skuInfo.skuNameRu,
                skuNameEn:skuInfo.skuNameEn,
                skuNo:item.skuNo,
                mainMaterials:skuInfo.mainMaterials,
                categoryName:skuInfo.categoryName,
                packagingType:packagingType,
                mark:sMark,
                downCustomsCode: sDownCustomsCode,
            })
        })
        return downList;
    }
    getCerId(str,pathname){
        let iId = str.length>0?str.substr(1,str.length):'';
        iId = iId?Number(iId):'';
        const isEdit = pathname.indexOf('View')>-1 ? false:true; // 查看模块不可编码
        this.setState({
            iId: iId,
            isEdit:isEdit
        })
        return iId;
    }
    /**
     * 表单
     * */
    formRef = React.createRef();
    /**
     * 渲染列表
     * **/
    renderAttribute(attributeList=[]){
        let childAtt = [];
        attributeList.forEach((att,inx)=>{
            if(att.optionList&&att.optionList.length>0)childAtt.push(<DescItem key={inx} label={att.attributeName}>{att.optionList.map((item, suinx)=>(<span key={suinx}>{item.optionName}</span>))}</DescItem>)
        })
        return childAtt;
    }
    /**
     * 渲染列表
     * **/
    renderOne(item={},isEdit=false,inx){
        const strNum = item['customsCode']&&item['customsCode'].length||0; //!isEmpty(item.customsCode)?item.customsCode.length:0;
        const skuInfo = item.skuInfo||{};
        return(<div className={'itemLi'} key={item.id}>
                <div className={'pro'}>
                    {item.skuFileUrls&&item.skuFileUrls.length>0&&<ImageHover src={item.skuFileUrls[0]} />}
                </div>
                <div className={'info'}>
                    <div className={'option'}>
                        <p>{Lang({id: "HaiGuanBianMa",default: "海关编码"})}</p>
                        <div className={'copyOption'}>
                            <Row gutter={24} className={'inputOption'}>
                                <Col span={18}>
                                        {/*<Form.Item*/}
                                            {/*name={'Input_Copy_'+inx}*/}
                                            {/*// name={'customsCode'}*/}
                                            {/*noStyle*/}
                                            {/*rules={[*/}
                                                {/*{ required:true, message: Lang({id: 'QingTianXieWeiShuDeHaiGuanBianMa', default:'请填写{0}位数的海关编码', params:[10]})*/}
                                                {/*},*/}
                                                {/*{*/}
                                                    {/*len: 10,*/}
                                                    {/*message: Lang({id: 'QingTianXieWeiShuDeHaiGuanBianMa', default:'请填写{0}位数的海关编码', params:[10]}),*/}
                                                {/*}*/}
                                            {/*]}*/}
                                        {/*>*/}
                                            <Input type='text'
                                                   disabled={!isEdit}
                                                   autoComplete={'off'}
                                                   maxLength={10}
                                                   id={'Input_Copy_'+inx}
                                                   value={item.customsCode}
                                                   onChange={(value)=>this.changeCusCode(value,inx)} />
                                        {/*</Form.Item>*/}
                                </Col>
                                {isEdit&&<Col span={6}>{strNum}<span>{Lang({id: "WeiShu",default: "位数"})}</span></Col>}
                            </Row>

                            {isEdit&&strNum!=10&&<div className={'inp-err'}>
                                {Lang({
                                    id:'QingTianXieWeiShuDeHaiGuanBianMa',
                                    default:'请填写{0}位数的海关编码',
                                    params:[10]
                                })}
                            </div>}
                            {isEdit&&<CopyAndPaste optionId={'Input_Copy_'+inx} pasteRes={(value)=>this.handlePasteRes(value,inx)} />}
                        </div>
                    </div>
                    <div className={'desc'}>
                        {/*<p>{skuInfo.skuNameRu}</p>*/}
                        <p className={'blackLink'}><a href={config.servers[config.environment].portalUrl+`/${item.goodsId}.html?skuNo=${item.skuNo}`} target={'_blank'}>{skuInfo.skuNameRu}</a></p>
                        <p className={'blackLink'}><a href={config.servers[config.environment].portalUrl+`/${item.goodsId}.html?skuNo=${item.skuNo}`} target={'_blank'}>{skuInfo.skuNameEn}</a></p>
                        {/*<p>{skuInfo.skuNameEn}</p>*/}
                        <Descriptions column={1}>
                            <DescItem label={Lang({id: 'ShangPinBianMa', default: '商品编码'})}>{skuInfo.skuNo}</DescItem>
                            <DescItem label={Lang({id: 'CaiZhi', default: '材质'})}>{skuInfo.mainMaterials}</DescItem>
                            <DescItem label={Lang({id: 'LeiMu', default: '类目'})}>{skuInfo.categoryName}</DescItem>
                            {/*<DescItem label={Lang({id: 'BaoZhuangNianLingBiaoQian', default: '包装年龄标签'})}>{skuInfo.mark}</DescItem>*/}
                            {/*<DescItem label={Lang({id: 'BaoZhuangLeiXing', default: '包装类型'})}>{skuInfo.packagingType}</DescItem>*/}
                            {this.renderAttribute(skuInfo.attributeList)}
                        </Descriptions>
                    </div>
                </div>
            </div>)
    }
    /**
     * 行编海关编码
     * */
    changeCusCode(e,inx){
        const { target:{value}} = e;
        // if(value.length<=10){
            this.setCusCode(value,inx);
        // }
        return;
    }
    // 限制粘贴字数
    handlePasteRes(value='',inx){
        if(value.length==10){
            this.setCusCode(value,inx);
        }else {
            message.info(Lang({
                id:'QingTianXieWeiShuDeHaiGuanBianMa',
                default:'请填写{0}位数的海关编码',
                params:[10]
            }))
            return false;
        }
    }
    setCusCode(value='',inx){
        const {list,isHadEdit} = this.state;
        let newList = [...list];
        newList[inx]['customsCode'] = value;
        newList[inx]['Input_Copy_'+inx] = value;
        this.setState({
            list:newList,
        })
        if(!isHadEdit)this.setHadEdit(true);
    }
    /**
     * 设置是否编辑过
     **/
    setHadEdit(flag){
        this.setState({
            isHadEdit : flag
        })
    }
    beforeUpload(file){
        if(file&&file.name){
            const sSuffix = getFileSuffix(file.name);
            // console.log('上傳前sSuffix', sSuffix)
            if(sSuffix!=='xlsx'&&sSuffix!=='xls'){
                message.warning(Lang({id:'WenJianGeShiBuZhengQue',default:'文件格式不正确，不能上传'}))
                return false;
            }
        }else {
            message.warning(Lang({id:'WenJianGeShiBuZhengQue',default:'文件格式不正确，不能上传'}));
            return false;
        }
    }
    /**
     * 上传文件后设置
     * **/
    handleUpload(file){
        this.loading(true);
        // 通过FileReader对象读取文件
        utilExcelStrict.readFileByBuffer(file.file, (data)=>this.handleUploadFile(data));
    }
    handleUploadFile(fileRow=[]){
        if(fileRow.length>0){
            const {list} = this.state;
            let newList = [...list];
            let errStr =''
            fileRow.forEach((row,inx)=>{
                if(inx>0){
                    const iCusCode = row[9]; // 海关编码
                    const currRow = newList[inx-1]||{};
                    if(!isEmpty(iCusCode)&&row[4]==currRow.skuNo){
                        newList[inx-1].customsCode = trim(iCusCode); //对应skuno
                    }else if(!isEmpty(currRow.skuNo))errStr += currRow.skuNo+'，';
                }
            })
            if(newList&&newList.length>0){
                this.setState({
                    list:newList
                })
                //需要回显自动验证时的有无证书checked
                // const { setFieldsValue } = this.formRef.current;
                // setFieldsValue(newList);
                // const values = this.formRef.current.validateFields();
                this.setHadEdit(true);
            }
            // 上传完成后提示
            if(isEmpty(errStr)){
                message.success(Lang({id:'ShangChuanChengGong', default:'上传成功'}))
            }else {
                Modal.info({
                    title: Lang({id:'ShangChuanChuLiJieGuo', default:'上传处理结果'}),
                    content: (
                        <div>
                          {errStr}{Lang({id:'ShangPinPiPeiShiBai', default:'商品匹配失败，请检查修改后重新上传。'})}
                        </div>
                    ),
                    onOk() {},
                });
            }

            this.loading(false);
        }else{
            message.warning(Lang({id:'ShangPinPiPeiShiBai', default:'商品匹配失败，请检查修改后重新上传。'}));
            this.loading(false);}
    }
    /**
     * 保存数据
     * @isSubmit  0 保存 1 提交
     * **/
    handleSaveData = async(isSubmit) =>{
        const {list} = this.state;
        this.loading(true);
        let postList = [];
        for(let i=0,iLen=list.length;i<iLen;i++){
            const item = list[i];
            if (isEmpty(item.customsCode)||item.customsCode.length!=10) { // if(value.length==10)
                message.info(
                    Lang({
                              id:'QingTianXieWeiShuDeHaiGuanBianMa',
                              default:'请填写{0}位数的海关编码',
                              params:[10]
                          })
                )
                this.loading(false);
                return
            }
            let poItem = {
                customsCode: item.customsCode,
                skuId: item.skuId,
                skuName: item.skuName,
                skuNo: item.skuNo,
                skuFileUrls: item.skuFileUrls,
            }
            if (!isEmpty(item.id)) poItem['id'] = item.id;
            if (!isEmpty(item.isTort)) poItem['isTort'] = item.isTort;
            if (!isEmpty(item.salePoStickerTrackId)) poItem['salePoStickerTrackId'] = item.salePoStickerTrackId;
            postList.push(poItem);
        }
        const postData = {
            isSubmit:isSubmit,
            items:postList
        }
        CustomsDeclarationStickerAction.saveCustomsCode(postData).then(res=>this.handleSaveRes(res.data,isSubmit)).catch(err=>this.handleSaveRes(err))
    }
    handleSaveRes(res,isSubmit){
        this.loading(false);
        const {success,valid,model,models} = res;
        if(success&&valid){
            this.setHadEdit(false); // 保存成功后 设置可直接离开
            if(isSubmit==1){
                message.success(Lang({id: "CaoZuoChengGong",default: "操作成功"}));
                this.setState({
                    isEdit:false
                })
                setTimeout(()=>{
                    this.props.history.push('/customsDeclarationSticker/customsCoding')
                },1000);
            }
            if(isSubmit==0)  message.success(Lang({id: "YiBaoCun",default: "已保存"}));
        }else if(res.message){
            message.warning(res.message);
        } else message.warning(Lang({id:'CaoZuoShiBai',default: "操作失败",}));
    }
    componentDidMount() {
        window.addEventListener('beforeunload', this.listener)
        const { location:{search,pathname} } = this.props;
        const sId = this.getCerId(search,pathname);
        this.getDetail(sId);
    }
    componentWillUnmount(){
        window.removeEventListener('beforeunload', this.listener)
        this.setState = (state, callback) => {
            return;
        }
    }
    render(){
        const { loading,item,list,isHadEdit,uploadSetting,isEdit,iId } = this.state;
        const currPageName = Lang({id: "TianXieHaiGuanBianMa",default: "填写海关编码"});
        return (<Spin tip='loading' spinning={loading}>
            <Prompt
                when={isHadEdit}
                message={() =>Lang({id:'LiKaiDangQianYeHou，SuoBianJiDeShuJuJiangBuKeHuiFu',default:'离开当前页后，所编辑的数据将不可恢复'})}
            />
            <CommonBreadcrumb list={[
                { name:currPageName,link:'/customsDeclarationSticker/customsCoding'},{name:item&&item.poCode?item.poCode:''}]}></CommonBreadcrumb>
            <div className="customsCodingDetailStyle">
                <div className={'content'}>
                    <div className={'title'}>{currPageName}</div>
                    <div className={'itemList'}>
                       {/*<Form ref={this.formRef} onFinish={this.handleSaveData} colon={false} autoComplete="off" name="dynamic_form_nest_item">*/}
                        {/*{list.map((field,inx) =>{*/}
                            {/*field['Input_Copy_'+inx] = field.customsCode;*/}
                            {/*return(  <Form.List name={field.id} key={inx} initialValue={field}>*/}
                                {/*{(fields, { add, remove }) => this.renderOne(field,isEdit,inx)}*/}
                                {/*</Form.List>*/}
                            {/*)  }*/}
                        {/*)}*/}
                        {/*</Form>*/}
                        {list.map((field,inx) =>{
                            field['Input_Copy_'+inx] = field.customsCode;
                            return this.renderOne(field,isEdit,inx)
                        })}
                    </div>
                </div>
                {isEdit&&<div className={'footer'}>
                    <Row>
                        <Col span={12} className={'footer-left'}>
                            <Upload {...uploadSetting}>
                                <Button className={'btn'}>{Lang({id:'ShangChuan2',default:'上传'})}</Button>
                            </Upload>
                            <Button className={'btn'} onClick={()=>this.handleDownExcel(list,item&&item.poCode?item.poCode:'')}>{Lang({id:'XiaZai',default:'下载'})}</Button>
                        </Col>
                        <Col span={12} className={'footer-right'}>
                            <span className={'btn'} onClick={()=>this.handleSaveData(0)}>{Lang({id:'BaoCun',default:'保存'})}</span>
                            <span className={'btn btn-red'} onClick={()=>this.handleSaveData(1)}>{Lang({id:'TiJiao',default:'提交'})}</span>
                        </Col>
                    </Row>
                </div>}

            </div>
        </Spin>)
    }
}
export default Details;